var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79961 0.899998L4.29961 11.05L3.69961 8.15C4.66628 8.15 5.46628 8.45 6.09961 9.05C6.73294 9.65 7.04961 10.45 7.04961 11.45C7.04961 12.45 6.73294 13.2667 6.09961 13.9C5.46628 14.5333 4.68294 14.85 3.74961 14.85C2.78294 14.85 1.98294 14.5333 1.34961 13.9C0.716276 13.2333 0.39961 12.4167 0.39961 11.45C0.39961 11.1167 0.416276 10.8 0.449609 10.5C0.516276 10.2 0.616276 9.85 0.74961 9.45C0.882943 9.01666 1.06628 8.5 1.29961 7.9L3.64961 0.899998H6.79961ZM16.2496 0.899998L13.7496 11.05L13.1496 8.15C14.1163 8.15 14.9163 8.45 15.5496 9.05C16.1829 9.65 16.4996 10.45 16.4996 11.45C16.4996 12.45 16.1829 13.2667 15.5496 13.9C14.9163 14.5333 14.1329 14.85 13.1996 14.85C12.2329 14.85 11.4329 14.5333 10.7996 13.9C10.1663 13.2333 9.84961 12.4167 9.84961 11.45C9.84961 11.1167 9.86628 10.8 9.89961 10.5C9.96628 10.2 10.0663 9.85 10.1996 9.45C10.3329 9.01666 10.5163 8.5 10.7496 7.9L13.0996 0.899998H16.2496Z",
    fill: "#1F3B98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.30ca5a3c7510a17b3c378be6fd29bc3b.svg";
export { ForwardRef as ReactComponent };